module.exports = __webpack_public_path__ + "img/JSD200.0f330a56.png";